import { Textarea, TextareaProps } from '@chakra-ui/react';
import React, { useEffect, useRef } from 'react';

const AutoResizeTextarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>((props, ref) => {
  const innerRef = useRef<HTMLTextAreaElement | null>(null);
  const combinedRef = (node: HTMLTextAreaElement | null) => {
    if (typeof ref === 'function') ref(node);
    else if (ref) (ref as React.MutableRefObject<HTMLTextAreaElement | null>).current = node;
    innerRef.current = node;
  };

  const resize = () => {
    const textarea = innerRef.current;
    if (textarea) {
      textarea.style.height = 'auto'; // reset
      textarea.style.height = `${textarea.scrollHeight}px`; // resize
    }
  };

  useEffect(() => {
    resize();
  }, [props.value]);

  useEffect(() => {
    const observer = new ResizeObserver(() => resize());
    if (innerRef.current) observer.observe(innerRef.current);
    return () => observer.disconnect();
  }, []);

  return <Textarea {...props} ref={combinedRef} overflow="hidden" padding={0} resize="none" />;
});

AutoResizeTextarea.displayName = 'AutoResizeTextarea';
export default AutoResizeTextarea;
